import { userHasMaxTier } from '../user';
import { PLAN_TIER } from '@wetransfer/transfer/constant/plan-tier';
import { PRICING, UPGRADE } from '@wetransfer/transfer/constant/routes';
import getQueryParameters from '@wetransfer/transfer/modules/url/params';
import { State } from '@wetransfer/transfer/store/types';

interface redirectRoute {
  route?: string;
  shouldRedirect: boolean;
}

export const getIsFromMarketing = (trackingParam: string): boolean => {
  const marketingCampaignTracking = 'PMP_camp_';

  return trackingParam
    ? trackingParam.includes(marketingCampaignTracking)
    : false;
};

const getMarketingRedirect = (
  user: State['user'],
  search: string,
  proToPremiumRedirect: redirectRoute
): redirectRoute | null => {
  if (!search) {
    return { shouldRedirect: false };
  }

  const params = getQueryParameters(search);

  const isFromMarketing = getIsFromMarketing(params['trk']);

  const desiredTier = params['tier'];

  if (isFromMarketing) {
    if (
      user.planTier === PLAN_TIER.PRO_2022 &&
      desiredTier === PLAN_TIER.PREMIUM_2022
    ) {
      return proToPremiumRedirect;
    }

    return { route: `${PRICING.route}${search}`, shouldRedirect: true };
  }

  return null;
};

const upgradeRedirect = (
  user: State['user'],
  search?: string
): redirectRoute => {
  if (!user.loggedIn) {
    return {
      shouldRedirect: false,
    };
  }

  const marketingRedirect = getMarketingRedirect(user, search, {
    shouldRedirect: false,
  });

  if (marketingRedirect) {
    return marketingRedirect;
  }

  // The user is landing from other part of the page.
  return { shouldRedirect: userHasMaxTier(user), route: '/' };
};

export const signUpRedirect = (
  user: State['user'],
  search: string = window.location.search
): redirectRoute => {
  if (!user.loggedIn) {
    return {
      shouldRedirect: false,
    };
  }

  const marketingRedirect = getMarketingRedirect(user, search, {
    shouldRedirect: true,
    route: UPGRADE.route,
  });

  if (marketingRedirect) {
    return marketingRedirect;
  }

  // The user is landing from other part of the page.
  return {
    shouldRedirect: true,
    route: !userHasMaxTier(user) ? UPGRADE.route : '/',
  };
};

export default upgradeRedirect;
